import styled from "styled-components";
import {ButtonStyled, ButtonV5} from "../../button/ButtonV5";
import {colorPalette} from "../../styles/colorPalette";
import WarningIcon from "../../icons/warning.svg?react";
import {baseDistance, FlexCenterStyle, fontSize, fontWeight, radius, VerticalFlexStyle} from "../../styles/styles";

interface IDetailsContentProps {
	readonly replacementText: "alignment" | "scale";
}

const DetailsContent = (props: IDetailsContentProps) => {
	const {replacementText} = props;

	if (replacementText === "alignment") {
		return (
			<>
				<p>It's recommended to skip background alignment.</p>
				<span>You can align the background later in a Space View.</span>
			</>
		);
	} else {
		return (
			<>
				<p>It's recommended to skip scaling this background.</p>
				<span>You can set the scale later in a Space View.</span>
			</>
		);
	}
};

interface ILargePDFWarningProps {
	readonly replacementText: "alignment" | "scale";
	readonly onRenderPDFClick: () => void;
	readonly onSkipClick: () => void;
	readonly isSkipped: boolean;
}

export const LargePDFWarning = (props: ILargePDFWarningProps) => {
	const {replacementText, onRenderPDFClick, onSkipClick, isSkipped} = props;

	return (
		<LargePDFWarningStyled className="LargePDFWarningStyled">
			<HeaderStyled>
				<WarningIcon />
				<h4>Complex File Detected!</h4>
			</HeaderStyled>
			<DetailsStyled>
				<DetailsContent replacementText={replacementText} />
			</DetailsStyled>
			<ButtonContainerStyled>
				<ButtonV5
					type="secondary"
					label={replacementText === "alignment" ? "Align Now" : "Scale Now"}
					onClick={onRenderPDFClick}
				/>
				<ButtonV5
					disabled={isSkipped}
					label={`${isSkipped ? "Skipped" : "Skip"}`}
					onClick={onSkipClick}
				/>
			</ButtonContainerStyled>
		</LargePDFWarningStyled>
	);
};

const HeaderStyled = styled.div`
	${VerticalFlexStyle};
	justify-content: center;
	align-items: center;
	gap: ${baseDistance.oh};
`;

const DetailsStyled = styled.div`
	${VerticalFlexStyle};
	align-items: center;
	justify-content: center;
	gap: ${baseDistance.oh};

	> span {
		font-style: italic;
		font-size: ${fontSize.md};
		line-height: 16px;
		font-weight: ${fontWeight.normal};
		color: ${colorPalette.gray.c700Dark};
	}
`;

const LargePDFWarningStyled = styled.div`
	${VerticalFlexStyle};
	width: 100%;
	height: 100%;
	justify-content: center;
	align-items: center;
	margin: 0 24px 24px 24px;
	padding: 24px;
	gap: 24px;
	border: 2px solid ${colorPalette.gray.c300};
	border-radius: ${radius.sm};

	h4 {
		text-align: center;
		font-weight: ${fontWeight.bold};
	}
`;

const ButtonContainerStyled = styled.div`
	${FlexCenterStyle}
	justify-content: center;
	gap: ${baseDistance.oh};

	${ButtonStyled} {
		min-width: 200px;
	}
`;
